<template>
	<div class="footer-container lg-contain-margin">
		<div class='footer-top'>
			<div class='footer-top-left'>
				<div class='top' v-if="this.getSettingConfig.getInfo('site_footer_logo')">
					<img :src="getSettingConfig.getInfo('site_footer_logo')" alt="">
				</div>
				<div class='bottom'>
					<ul>

						<li v-for="item in page_list" :key="item.id">
							<router-link :to="{name:'single_page',query:{id:item.id}}">{{item.name}}</router-link>
						</li>
						<li><router-link :to="{name:'feedback_detail'}">意见反馈</router-link></li>
					</ul>
				</div>
			</div>
			<div class="footer-top-right">
				<div style="position:relative;">
					<img v-if="getSettingConfig.getInfo('wechat_qrcode') !==null" src="../assets/img/index/weixin.png" alt="" class="wx-icon">
					<div class="wx-code" v-if="getSettingConfig.getInfo('wechat_qrcode') !==null"><img :src="getSettingConfig.getInfo('wechat_qrcode')" alt="" ></div>
				</div>
				<a v-if="getSettingConfig.getInfo('weibo') !==null" target="_blank" :href="getSettingConfig.getInfo('weibo')"><img src="../assets/img/index/weibo.png" alt=""></a>
			</div>
		</div>
		<div class="footer-line"></div>
		<div class="footer-bottom">
			<ul>
				<li v-if="this.getSettingConfig.getInfo('record_code')">
					<span><a target="_blank" :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+this.getSettingConfig.getInfo('record_code')">
						<img src="../assets/img/police.png" alt="">滇公网安备 {{this.getSettingConfig.getInfo('record_code')}} 号
					</a></span>

					<span><a target="_blank" href="https://beian.miit.gov.cn">{{this.getSettingConfig.getInfo('icp')}}</a></span>
					<span>广播电视节目制作经营许可证：{{this.getSettingConfig.getInfo('tv')}}</span>
					<span>增值电信业务经营许可证：{{this.getSettingConfig.getInfo('telecom')}}</span>
				</li>
				<li>
					<span><a target="_blank" href="https://www.12377.cn/">网上有害信息举报专区</a> </span>
					<span>不良信息举报电话：{{this.getSettingConfig.getInfo('report_tel')}}</span>
					<span>举报邮箱：{{this.getSettingConfig.getInfo('report_email')}} </span>
					<span>联系电话：{{this.getSettingConfig.getInfo('tel')}}</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
    data () {
        return {
          page_list:[]
        }
    },
    created() { this.$requestApi.index.getPageTab({nav:true}).then(res => { this.page_list = res.data }) }
}
</script>

<style scoped lang="less">
.footer-container{
    background-color: #282828;
    overflow:visible !important;
    position: relative;
	min-height: 210px;
    .footer-top{
    display: flex;
    background-color: #282828;
    padding-bottom: 18px;
    align-items: center;
    justify-content: space-between;
	  position: relative;
        .footer-top-left{
            margin-top: 20px;
            .top{
	            width: 185px;
	            height: 38px;
	            margin-bottom: 20px;
	            img{
		            width: auto;
		            height: auto;
		            max-width: 100%;
		            max-height: 100%;
	            }
            }
            .bottom{
                ul{
                    display: flex;
                    li{
                        font-size: 14px;
                        margin-right: 41px;
                        color: #d1d1d1;
                        white-space: nowrap;
                        cursor: pointer;
                        a{
                            font-size: 14px;
                            color: #d1d1d1;
                        }
                    }
                }
            }
        }
        .footer-top-right{
            white-space: nowrap;
	        margin-top: 20px;
	        display: flex;
            .wx-code{
                position: absolute;
                background-color: #FFFFFF;
                height: 100px;
	            bottom: 50px;
	            right: 0;
                z-index: 99999;
                text-align: center;
                border-radius: 6px;
                display: none;
	            box-shadow:0 0 3px #aaaaaa;
                img{
                    width: 110px;
                    height: 110px;
                    margin: 0;
                    display: inline-block;
                    border-radius: 6px;
                }
            }
            .wx-code:after{
                content: "";
                border-top: 10px solid #fff;
                border-right: 10px solid transparent;
                border-bottom: none;
                border-left: 10px solid transparent;
                position: absolute;
                bottom: -20px;
                left: 50%;
                margin-left: -10px;
                display: block;
            }
            .wx-icon:hover +.wx-code{
                display: block;
            }
            img{
                width: 24px;
                height: 20px;
                display: inline-block;
                margin-right: 40px;
                cursor: pointer;
            }
        }
    }
    .footer-line{
    width: 1430px;
    height: 1px;
    background-color: #2D2D2D;
    margin: 0 auto 15px;
  }
    .footer-bottom{
        background-color: #282828;
        overflow: hidden;
        padding-bottom: 12px;
        span,a{
            color: #d1d1d1;
            font-size: 12px;
	        display: flex;
	        align-items: center;
	        img{
		        height: 20px;
		        margin-right: 10px;
	        }
        }
        li{
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            span:not(:last-child):after{
                content: "|";
                font-size: 12px;
                color: #666666;
                margin: 0 20px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue